// @flow
import maskInput from '../../utils/maskInput';
import JQueryView, { on, removeInvalidFeedback } from '../common/JQueryView';
import { purpose } from '../../models/companies/Company';
import { informationSource } from '../../models/User';

declare var $: any;

export default class Form2View extends JQueryView {
  constructor() {
    super('.simple_form');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    this.renderAdditionalForm();
  }

  @on({ event: 'change', selector: '#user_purpose_id' })
  onChangePurposeId() {
    this.renderAdditionalForm();
  }

  @on({ event: 'change', selector: '#user_information_source_id' })
  onChangeInformationSourceId() {
    this.renderAdditionalForm();
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  @on({ event: 'blur', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.hasClass('date-field2') && $('.show-calendar').is(':visible')) {
      target.addClass('form-control-active');
      target.addClass('focus');
    } else {
      if (target.val().length === 0) {
        target.removeClass('form-control-active');
      } else {
        target.addClass('form-control-active');
        target.removeClass('is-invalid');
        removeInvalidFeedback(target);
      }
    }
  }

  renderAdditionalForm() {
    const purposeId = $('#user_purpose_id').val();
    const InformationSourceId = $('#user_information_source_id').val();
    $('.display-purpose-note').css(
      'display',
      parseInt(purposeId) === purpose.other ? 'block' : 'none',
    );
    $('.user_stockholder_meeting_plan_id').css(
      'display',
      parseInt(purposeId) === purpose.stockholderMeeting ? 'block' : 'none',
    );
    $('.display-information-source-note').css(
      'display',
      parseInt(InformationSourceId) === informationSource.other
        ? 'block'
        : 'none',
    );
    maskInput();
  }
}
